import { Helmet } from 'react-helmet';
import { useEffect, useState } from 'react';
import { Redirect, 
  // useNavigate 
  useLocation
} from 'react-router-dom';
import {
  Box,
  Container,
  Grid
} from '@material-ui/core';
import Face from 'src/components/account/user/Face';
import ValidId from 'src/components/account/user/ValidId';
import Poi from 'src/components/account/user/Poi';

import AccountProfileDetails from 'src/components/account/user/AccountProfileDetails';
import Address from 'src/components/account/user/Address';

import { useDispatch, useSelector } from "react-redux";

//Components
import { SET_BACKBTN } from 'src/redux/actions/types';

const Account = () => {
  const token = localStorage.accessToken;
  const { user } = useSelector(state => state.auth);
  const dispatch = useDispatch();

  let { search } = useLocation();
  const [values, setValues] = useState({
    validId: '/static/validID.jpg',
    face: '/static/face.jpg',
    poi: '/static/payslip1.jpg'
  })
  

  useEffect(() => {
    var uri = window.location.toString();
    if (uri.indexOf("?") > 0) {

        let pr = search.split("?")[1];
        var clean_uri = uri.substring(0, uri.indexOf("?"));
        let el = document.getElementById(pr);
       el && el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        window.history.replaceState({}, document.title, clean_uri);

    }
  }, [])


  useEffect(() => {
    if(user && user.personalDetails){
      setValues({...values, ...user.personalDetails})
    }
  }, [user])


  
useEffect(() => {
  dispatch({
    type: SET_BACKBTN,
    payload: '/app/dashboard'
  })
}, [])




  if (!token) {
    return <Redirect to="/login" />;
  }

  return(
  <>
    <Helmet>
      <title>Account | Transac</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container maxWidth="lg">
        <Grid
          container
          spacing={2}
        >

          <Grid
            item
            lg={8}
            md={8}
            xs={12}
          >

<div id="informations">

<AccountProfileDetails />
</div>

          </Grid>
          <Grid
            item
            lg={4}
            md={4}
            xs={12}
          >
                    <div id="address">

            <Address />
          </div>

          </Grid>
          <Grid
            item
            lg={4}
            md={4}
            xs={12}
          >

          <div id="face">
            <Face image={values.face} title="Face Image" ids="face"/>
            </div>
          </Grid>
          <Grid
            item
            lg={4}
            md={4}
            xs={12}
          >
           <div id="validId">
            <ValidId image={values.validId} title="Valid ID" ids="validId"/>
            </div>
          </Grid>
          <Grid
            item
            lg={4}
            md={4}
            xs={12}
          >
            <div id="poi">
            <Poi  image={values.poi}  title="Proof of Income" ids="poi"/>
            </div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  </>
);
 }

export default Account;
